<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <!--                        <h4 class="card-title mb-4">Open Batch</h4>-->
            <!-- Supposed Form -->
            <div class="form-body">
              <AddEntryToBatchForm />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import AddEntryToBatchForm from "../../components/Kleyton/Forms/Journal/AddEntryToBatchForm";

export default {
  name: "AddEntryToBatch",
  page: {
    title: "Add Entry To Batch",
    meta: [{ name: "Add Entry To Batch", content: window.__env.app.description }]
  },

  components: {
    AddEntryToBatchForm,
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "AddEntryToBatch",
      title: "Add Entry To Batch",
      items: [
        {
          text: "Batch",
          href: "/"
        },
        {
          text: "Add Entry To Batch",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
